var _style, _defs, _defs2, _path, _path2, _path3, _path4, _defs3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.99 32.52",
    style: {
      enableBackground: "new 0 0 85.99 32.52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000013879017012722169840000003113734437488025514_);fill:#D64527;}\n\t.st1{clip-path:url(#SVGID_00000101081682023600905830000002736760735851240075_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000132789122947447498980000008752346098725633411_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M18.28,3.02h50c2.21,0,4,1.79,4,4v18c0,2.21-1.79,4-4,4h-50c-2.21,0-4-1.79-4-4v-18 C14.28,4.81,16.07,3.02,18.28,3.02z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108998086184117001780000007655687239615059122_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.28,
    y: 2.02,
    style: {
      clipPath: "url(#SVGID_00000108998086184117001780000007655687239615059122_)",
      fill: "#D64527"
    },
    width: 60,
    height: 28
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044176363940843561250000011502465423014599082_",
    x: 38.28,
    y: 5.52,
    width: 26,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145764173069397157820000012122865903041750188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044176363940843561250000011502465423014599082_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145764173069397157820000012122865903041750188_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.59,16.87h-4.32v5.65h-1.61V9.73h6.66v1.39h-5.05v4.38h4.32V16.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.66,22.52c-0.05-0.12-0.1-0.27-0.13-0.45c-0.03-0.18-0.06-0.38-0.07-0.58c-0.11,0.16-0.24,0.32-0.38,0.47 s-0.3,0.28-0.48,0.39s-0.37,0.2-0.58,0.26s-0.43,0.1-0.66,0.1c-0.42,0-0.79-0.06-1.13-0.18s-0.63-0.29-0.87-0.53 s-0.42-0.52-0.55-0.87c-0.13-0.34-0.19-0.74-0.19-1.2s0.08-0.88,0.24-1.27s0.39-0.72,0.7-1s0.7-0.5,1.17-0.66s1.01-0.24,1.63-0.24 h1.08v-1.01c0-0.57-0.13-0.97-0.38-1.21s-0.64-0.36-1.15-0.36c-0.25,0-0.48,0.04-0.67,0.12c-0.2,0.08-0.36,0.19-0.5,0.32 s-0.24,0.29-0.31,0.47s-0.11,0.37-0.11,0.57h-1.56c0-0.34,0.07-0.68,0.22-1.02c0.15-0.34,0.36-0.64,0.64-0.9s0.62-0.48,1.02-0.65 s0.84-0.25,1.34-0.25c0.44,0,0.84,0.05,1.21,0.16s0.68,0.28,0.95,0.51s0.47,0.54,0.62,0.91s0.22,0.82,0.22,1.35v4.68 c0,0.16,0.01,0.33,0.02,0.5s0.03,0.35,0.06,0.52s0.06,0.33,0.1,0.49s0.08,0.3,0.13,0.43v0.14H52.66z M50.59,21.28 c0.22,0,0.42-0.03,0.62-0.1s0.37-0.15,0.53-0.25s0.3-0.22,0.42-0.35c0.12-0.13,0.22-0.27,0.29-0.41v-2.27h-0.82 c-0.38,0-0.71,0.04-1.02,0.12s-0.56,0.2-0.77,0.36s-0.38,0.35-0.49,0.58s-0.17,0.49-0.17,0.78c0,0.29,0.03,0.53,0.09,0.72 c0.06,0.2,0.15,0.36,0.26,0.47c0.12,0.12,0.27,0.21,0.44,0.26S50.35,21.28,50.59,21.28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.39,10.49c0-0.26,0.07-0.49,0.22-0.67s0.37-0.27,0.66-0.27s0.51,0.09,0.66,0.28 c0.15,0.18,0.22,0.41,0.22,0.66c0,0.26-0.07,0.48-0.22,0.66s-0.37,0.26-0.67,0.26c-0.29,0-0.51-0.09-0.66-0.26 S56.39,10.75,56.39,10.49z M58.03,22.52h-1.56v-9.51h1.56V22.52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.12,22.52h-1.56V9.02h1.56V22.52z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000165918447603110645040000007315650432698690207_",
    points: "32.78,11.63 31.67,10.52 27.28,14.92  22.89,10.52 21.78,11.63 26.17,16.02 21.78,20.42 22.89,21.52 27.28,17.13 31.67,21.52 32.78,20.42 28.39,16.02  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120529070221791105510000006014826037966170519_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000165918447603110645040000007315650432698690207_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 9.52,
    style: {
      clipPath: "url(#SVGID_00000120529070221791105510000006014826037966170519_)",
      fill: "#FFFFFF"
    },
    width: 13,
    height: 13
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailStatus);
export default __webpack_public_path__ + "static/media/fail-status.e1ea0ff26b10b75a421be5b73e80be43.svg";
export { ForwardRef as ReactComponent };